import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import Seo from '~/components/functional/Seo/EditorialSeo.vue';
import OpenGraph from '~/components/functional/OpenGraph/EditorialOpenGraph.vue';
import TcVars from '~/components/functional/TcVars/EditorialTcVars.vue';
import { PRISMIC_URL, WOOSMAP_KEY, WOOSMAP_RECOMMENDATION } from '~/const/3rd';
import { formatPrismicImage } from '~/helpers/image-helper';
import { componentList, typeDefinition, buildSlices } from '~/helpers/editorial-helper';
import { fetchContent } from '~/services/editorial';
import HomeJsonld from '~/components/functional/JsonLD/HomepageJsonld.vue';
import RatingJsonLd from '~/components/functional/RatingJsonLd.vue';
const components = {};

const MarketSwitcher = () => import(
/* webpackChunkName: "market-switcher" */
'~/components/atoms/Global/MarketSwitcher.vue');

componentList().forEach(e => {
  components[e.type || e.name] = slug => ({
    component: import("~/components/organisms/Editorial/".concat(slug))
  });
});
export default {
  name: 'Home',
  components: {
    Seo,
    OpenGraph,
    TcVars,
    HomeJsonld,
    RatingJsonLd
  },

  asyncData(_ref) {
    return _asyncToGenerator(function* () {
      let {
        error,
        app: {
          apolloProvider
        },
        store
      } = _ref;

      try {
        const definition = typeDefinition('home');
        const {
          results: [{
            id,
            data
          }]
        } = yield fetchContent(store, {
          type: 'home'
        });
        const slices = yield buildSlices(definition, data, apolloProvider.defaultClient, store);
        return {
          type: definition.type,
          template: {
            path: definition.path,
            data
          },
          id,
          slices
        };
      } catch (e) {
        error({
          statusCode: 404,
          message: 'Not Found'
        });
      }

      return false;
    })();
  },

  data() {
    return {
      marketSwitcher: null
    };
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),
  httpHeaders: () => ({
    'Cache-Control': 'max-age=0, s-maxage=360, public'
  }),

  created() {
    if (this.template.path) {
      this[this.type] = () => components[this.type](this.template.path);
    }

    this.slices.forEach((_ref2) => {
      let {
        type,
        path
      } = _ref2;

      this[type] = () => components[type](path);
    });
  },

  beforeMount() {
    const prismicEdit = this.$cookies.get('editor');

    if (prismicEdit) {
      window.prismic = {
        endpoint: this.$store.state.sharedEnv.payload.prismic
      };
      this.asyncScript(PRISMIC_URL).then(() => {}).catch(err => {
        this.$logger.error("PRISMIC FAILED ".concat(err));
      });
    }
  },

  mounted() {
    if (!this.$cookies.get('MARKET_SWITCHER_DISMISSED') && window.woosmapRecommendation) {
      const that = this;
      window.woosmapRecommendation.setProjectKey(WOOSMAP_KEY);
      window.woosmapRecommendation.getUserPosition({
        successCallback(latlng) {
          if ('latitude' in latlng) {
            const US_BOUND_BOX = {
              lat: {
                north: 49.3457868,
                south: 24.7433195
              },
              lng: {
                west: -124.7844079,
                east: -66.9513812
              }
            };

            if (US_BOUND_BOX.lat.south < latlng.latitude < US_BOUND_BOX.lat.north && US_BOUND_BOX.lng.west < latlng.longitude < US_BOUND_BOX.lng.east) {
              that.marketSwitcher = MarketSwitcher;
              return;
            }
          }

          that.setMarketSwitcherOffCookie(3600 * 24);
        }

      });
    }

    if (this.$cookies.get('opensearch') === 1) {
      window.addEventListener('load', () => {
        this.$root.$emit('open-search-mobile');
      }, {
        passive: true
      });
      this.$root.$emit('open-search-mobile');
    }
  },

  destroyed() {
    this.$root.$emit('close-search-mobile');
  },

  methods: {
    currentComponent(arg) {
      return this[arg];
    },

    options(_ref3) {
      let {
        global_background_color: backgroundColor,
        global_background_image: image
      } = _ref3;
      return process.browser ? _objectSpread({}, backgroundColor && {
        style: {
          backgroundColor
        }
      }, image && image.url && {
        'data-bgset': formatPrismicImage(image.url),
        class: 'lazyload bg-center'
      }) : null;
    },

    setMarketSwitcherOffCookie(maxAge) {
      this.$cookies.set('MARKET_SWITCHER_DISMISSED', '1', {
        path: '/',
        maxAge
      });
    }

  },

  head() {
    return {
      script: [{
        src: WOOSMAP_RECOMMENDATION,
        body: true
      }]
    };
  }

};